import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PassengerType } from 'src/app/core/enums/enums';
import { Passenger } from 'src/app/core/models/itinerary.model';

export interface IAdultSelected {
  fromAdultID: string;
  infantID: string;
  toAdultFullName: string;
  toAdultID: string;
}

@Component({
  selector: 'app-infant-reasignation-modal',
  templateUrl: './infant-reasignation-modal.component.html',
  styleUrls: ['./infant-reasignation-modal.component.css']
})
export class InfantReasignationModalComponent implements OnChanges {
  @Input() isActive: boolean;
  @Input() name: string;
  @Input() infantID: string;
  @Input() allPassengers: Passenger[];
  @Input() adultInCharge: string;

  @Output() closeModal = new EventEmitter<boolean>();
  @Output() acceptModal = new EventEmitter<IAdultSelected>();

  form: UntypedFormGroup;
  availableAdults: IAdultSelected[] = [];
  availableAdultsList: string[] = [];

  constructor(private fb: UntypedFormBuilder) {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.adultInCharge?.currentValue) {
      this.availableAdultsList = [];
      this.allPassengers.forEach((passenger) => {
        const fullname = `${passenger.firstName} ${passenger.lastName}`;

        if (!fullname.includes(changes.adultInCharge.currentValue)) {
          switch (passenger.type) {
            case PassengerType.Adult:
              this.availableAdults.push({
                toAdultFullName: this.capitalizeFullName(passenger.firstName, passenger.lastName),
                fromAdultID: this.allPassengers.find((passenger) =>
                  `${passenger.firstName} ${passenger.lastName}`.includes(
                    changes.adultInCharge.currentValue
                  )
                ).id,
                toAdultID: passenger.id,
                infantID: this.infantID
              });
              this.availableAdultsList.push(
                this.capitalizeFullName(passenger.firstName, passenger.lastName)
              );
              break;
          }
        }
      });
    }
  }

  buildForm() {
    this.form = this.fb.group({
      toAdult: ['', Validators.required]
    });
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  capitalizeFullName(firstName: string, lastName: string): string {
    return `${firstName} ${lastName}`
      .toLowerCase()
      .split(' ')
      .map(this.capitalizeFirstLetter)
      .join(' ');
  }

  sendAcceptModal() {
    const found = this.availableAdults.find((adult) =>
      this.form.value.toAdult.includes(adult.toAdultFullName)
    );

    this.acceptModal.emit(found);
  }
}
